import {isGranted, loadGrants} from "@dealer-group/dealerui";

export async function useGrants() {
    await loadGrants();
    return isGranted;
}